@if (currentStep !== 'none') {
  <div class="modal-overlay" [@fadeAnimation] (keydown.escape)="closeModal()" role="presentation">
    <div class="modal-container" #modalContainer [@slideAnimation] tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="form-modal-title">
      <button class="close-button" (click)="closeModal()" aria-label="Fermer la fenêtre">×</button>
      <div class="steps-indicator">
        <div class="step" [class.active]="currentStep === 'one'">1</div>
        <div class="step-line"></div>
        <div class="step" [class.active]="currentStep === 'two'">2</div>
        <div class="step-line"></div>
        <div class="step" [class.active]="currentStep === 'three'">3</div>
      </div>
      <div class="modal-content">
        <div class="modal-header-center">
          <div class="modal-logo">
            <img src="https://applisound-images.s3.eu-west-3.amazonaws.com/applisound-bleu.png" alt="Applisound" class="applisound-logo">
          </div>
          <h2 id="form-modal-title">{{ 'FORM_MODAL.TITLE' | translate }}</h2>
        </div>
        <app-form-unified
          [serviceType]="serviceType"
          (next)="onNextStep($event)"
          (previous)="onPreviousStep($event)"
          (cancel)="closeModal()"
          (complete)="onFormComplete($event)"
          >
        </app-form-unified>
      </div>
    </div>
    <!-- Confirmation dialog -->
    @if (showConfirmation) {
      <div class="confirmation-dialog" [@confirmAnimation]>
        <div class="confirmation-content">
          <h3>Quitter le formulaire ?</h3>
          <p>Vos données ne seront pas sauvegardées.</p>
          <div class="confirmation-buttons">
            <button class="btn-cancel" (click)="cancelClose()">
              Continuer l'édition
            </button>
            <button class="btn-confirm" (click)="confirmClose()">Quitter</button>
          </div>
        </div>
      </div>
    }
  </div>
}